module.exports = __webpack_public_path__ + "b10985f6d0da277d66cb7f9f727728fd.png";


//////////////////
// WEBPACK FOOTER
// ./images/edit-icon.png
// module id = 447
// module chunks = 0